import { render, staticRenderFns } from "./brandLive.vue?vue&type=template&id=6c578774&scoped=true"
import script from "./brandLive.vue?vue&type=script&lang=js"
export * from "./brandLive.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/brandLive.css?vue&type=style&index=0&id=6c578774&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c578774",
  null
  
)

export default component.exports